// PWA Install Prompt — Annabelle's Wigs
(function () {
  'use strict';

  var DISMISSED_KEY = 'pwa_banner_dismissed';
  var VISIT_KEY    = 'pwa_visit_count';
  var SESSION_KEY  = 'pwa_session_counted';
  var deferredPrompt = null;

  // Don't show if dismissed within the last 24 hours
  var _dismissed = localStorage.getItem(DISMISSED_KEY);
  if (_dismissed && Date.now() - parseInt(_dismissed, 10) < 86400000) return;

  // Count visits — once per browser session (refreshes don't count)
  if (!sessionStorage.getItem(SESSION_KEY)) {
    sessionStorage.setItem(SESSION_KEY, '1');
    var _visits = parseInt(localStorage.getItem(VISIT_KEY) || '0', 10) + 1;
    localStorage.setItem(VISIT_KEY, _visits.toString());
  }

  // Only show from the 2nd visit onwards
  if (parseInt(localStorage.getItem(VISIT_KEY) || '0', 10) < 2) return;

  // Only show on mobile
  if (window.matchMedia('(min-width: 768px)').matches) return;

  // Don't show if already running as installed PWA
  if (window.matchMedia('(display-mode: standalone)').matches) return;
  if (window.navigator.standalone === true) return;

  var isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
  var isAndroid = /android/i.test(navigator.userAgent);

  // Register service worker
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js').catch(function (err) {
      console.warn('SW registration failed:', err);
    });
  }

  function dismiss() {
    localStorage.setItem(DISMISSED_KEY, Date.now().toString());
    hideBanner();
    hideIosTip();
  }

  function hideBanner() {
    var banner = document.getElementById('pwa-install-banner');
    if (banner) {
      banner.classList.remove('is-visible');
    }
  }

  function hideIosTip() {
    var tip = document.getElementById('pwa-ios-tip');
    if (tip) {
      tip.classList.remove('is-visible');
    }
  }

  function showAndroidBanner() {
    var banner = document.getElementById('pwa-install-banner');
    if (!banner) return;
    banner.classList.add('is-visible');

    var installBtn = banner.querySelector('.pwa-banner__btn--install');
    var dismissBtn = banner.querySelector('.pwa-banner__btn--dismiss');

    if (installBtn) {
      installBtn.addEventListener('click', function () {
        if (deferredPrompt) {
          deferredPrompt.prompt();
          deferredPrompt.userChoice.then(function (choice) {
            if (choice.outcome === 'accepted') {
              dismiss();
            }
            deferredPrompt = null;
          });
        }
      });
    }

    if (dismissBtn) {
      dismissBtn.addEventListener('click', dismiss);
    }
  }

  function showIosTip() {
    var tip = document.getElementById('pwa-ios-tip');
    if (!tip) return;
    tip.classList.add('is-visible');

    // Keep the tip above Safari's bottom toolbar (home indicator + tab bar)
    // visualViewport tells us exactly how much browser chrome is covering the bottom
    function updateTipPosition() {
      if (window.visualViewport) {
        var chromeBottom = window.innerHeight - window.visualViewport.offsetTop - window.visualViewport.height;
        tip.style.bottom = Math.max(0, chromeBottom) + 'px';
      }
    }
    updateTipPosition();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateTipPosition);
      window.visualViewport.addEventListener('scroll', updateTipPosition);
    }

    var closeBtn = tip.querySelector('.pwa-ios-tip__x');
    if (closeBtn) {
      closeBtn.addEventListener('click', dismiss);
    }
  }

  // Android: wait for browser's beforeinstallprompt event
  if (isAndroid) {
    window.addEventListener('beforeinstallprompt', function (e) {
      e.preventDefault();
      deferredPrompt = e;
      showAndroidBanner();
    });
  }

  // iOS Safari: show manual tip (no native prompt available)
  if (isIOS) {
    document.addEventListener('DOMContentLoaded', function () {
      // Small delay so page feels loaded first
      setTimeout(showIosTip, 2500);
    });
  }
})();
